import { ensureSendThreadId } from './helpers/ensureSendThreadId'
import { runPreparedSendTurn } from './helpers/runPreparedSendTurn'

/** @param {object} m @param {{ text: string, files?: unknown[], connectContext?: unknown, forceNewThread?: boolean, proposalId?: string, researchMode?: 'auto' | 'required', refinement?: object }} payload */
export function runSendMessage(m, { text, files, connectContext, forceNewThread = false, proposalId, researchMode, refinement, model, openStream, chatId, isProvisionalHomeThread }) {
  const {
    activePrimaryKey,
    displayThreadId,
    navThreads,
    setThreads,
    setSelectedThreadId,
    setMainAskBarPrefill,
    activeProjectId,
  } = m
  if (activePrimaryKey !== 'home') return
  const trimmed = text.trim()
  if (!trimmed && (!files || files.length === 0)) return
  const tid = ensureSendThreadId({
    currentId: displayThreadId,
    forceNewThread,
    validIds: navThreads.map((t) => t.id),
    setThreads,
    setActiveThreadId: setSelectedThreadId,
    trimmed,
    files,
    activeProjectId,
    provisionalId: isProvisionalHomeThread ? chatId : null,
  })
  const selectedModel = model ?? m.navThreads.find((thread) => thread.id === tid)?.model ?? 'auto'
  const started = runPreparedSendTurn(m, { tid, trimmed, files, connectContext, proposalId, researchMode, refinement, model: selectedModel, openStream })
  if (!started) return
  setMainAskBarPrefill?.(null)
}
